import React from 'react';
import styled from 'styled-components';
import { Typography } from 'antd';
import { useTheme } from '../../../contexts/ThemeContext';
import { FileExclamationOutlined } from '@ant-design/icons';

interface NoDataPlaceholderProps {
  height?: number;
  message?: string;
  className?: string;
}

const { Text } = Typography;

const PlaceholderContainer = styled.div<{ $isDark: boolean; height: number }>`
  height: ${props => props.height}px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${props => props.$isDark ? 'rgba(20, 20, 20, 0.7)' : '#fafafa'};
  border: 1px solid ${props => props.$isDark ? '#303030' : '#f0f0f0'};
  border-radius: 4px;
  padding: 24px;
  transition: background-color 0.3s ease, border-color 0.3s ease;
`;

const IconWrapper = styled.div<{ $isDark: boolean }>`
  font-size: 24px;
  margin-bottom: 12px;
  color: ${props => props.$isDark ? '#d9d9d9' : '#bfbfbf'};
`;

const NoDataPlaceholder: React.FC<NoDataPlaceholderProps> = ({ 
  height = 300, 
  message = 'No data available', 
  className 
}) => {
  const { theme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <PlaceholderContainer $isDark={isDark} height={height} className={className}>
      <IconWrapper $isDark={isDark}>
        <FileExclamationOutlined />
      </IconWrapper>
      <Text style={{ 
        fontSize: '14px', 
        color: isDark ? '#d9d9d9' : '#00000073',
        textAlign: 'center'
      }}>
        {message}
      </Text>
    </PlaceholderContainer>
  );
};

export default NoDataPlaceholder; 